import React, { useState, useEffect } from 'react'
import styles from './styles.module.scss'
import parentStyles from '../styles.module.scss'
import EmptyCard from 'srcReact/Dashboard/components/common/EmptyCard'
import MixrActivityGraph from '../MixrActivityGraph'
import { useTranslation } from 'react-i18next'
import CardSubTitle from 'srcReact/Dashboard/components/common/CardSubTitle'
import Counts from 'srcReact/Dashboard/components/common/Counts'
import AnchorLink from 'srcReact/components/common2/AnchorLink'
import { isMobileScreen } from 'srcReact/helpers/utils'

function MixrsActivity({ objectId, mixrsActivityData, duration, loading }) {
  const { t } = useTranslation()
  const [mixrData, setMixrData] = useState(null)
  const [graphData, setGraphData] = useState(null)
  useEffect(() => {
    if (mixrsActivityData && mixrsActivityData[duration]) {
      const durationData = mixrsActivityData[duration]
      if (durationData) {
        setMixrData(durationData)
      }
      if (duration === '4W') {
        setGraphData(mixrsActivityData['7D'])
      } else if (duration === '88D') {
        setGraphData(mixrsActivityData['22D'])
      } else {
        setGraphData(mixrsActivityData['91D'])
      }
    }
  }, [mixrsActivityData, duration])

  return (
    <div className={parentStyles.activityData}>
      <div className={parentStyles.left}>
        {mixrData?.new_mixr?.length > 0 ? (
          <div className={parentStyles.list}>
            {mixrData?.new_mixr.map((mixr, index) => {
              const mixrInfo = mixr.mixr_info
              return (
                <AnchorLink
                  path={mixrInfo?.url || ''}
                  key={mixrInfo?.id}
                  className={styles.listItem}
                  handleClick={(e) => {
                    if (!mixrInfo?.url) {
                      e.preventDefault()
                    }
                  }}>
                  <div className={`${styles.picture} ${styles[mixrInfo?.color] || styles['blue']}`} />
                  <div className={styles.mixrInfo}>
                    <p className={styles.time}>{mixr.participant_count}</p>
                    <p className={styles.text}>{mixrInfo?.name}</p>
                  </div>
                </AnchorLink>
              )
            })}
          </div>
        ) : (
          <EmptyCard
            className={styles.invites}
            contentTitle={t('dashboard.activity.newMixrs.empty.title')}
            contentText={t('dashboard.activity.newMixrs.empty.text')}
            contentImage='void'
            contentButton={t('nav.create_mixr')}
            contentButtonLink={`/0/create-mixr`}
            linkTarget='_blank'
          />
        )}
      </div>
      {!isMobileScreen() && (
        <div className={parentStyles.right}>
          <Counts
            countTitle={t('dashboard.activity.newMixrs.participationCount', {
              count: parseInt(mixrData?.participation_count?.value)
            })}
            totalCountTitle={t('dashboard.activity.newMixrs.participantCount', {
              count: parseInt(mixrData?.participant_count?.value)
            })}
            count={mixrData?.participation_variation?.value}
            totalCount={mixrData?.participant_variation?.value}
          />
          <MixrActivityGraph graphData={graphData?.mixrs_graph} />
        </div>
      )}
    </div>
  )
}

export default MixrsActivity
